import { useCallback } from 'react';

import type { GqlFetch } from '@change-corgi/core/gql';
import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import type { Session } from 'src/shared/session';
import { getSession } from 'src/shared/session';

export function useGetNewSession(): () => Promise<Session> {
	const {
		gql: { fetch },
		errorReporter: { report },
		csrf: { refreshCsrfToken },
	} = useUtilityContext();

	return useCallback(async () => {
		const newSession = await getSession({
			gqlFetch: fetch as GqlFetch,

			reportError: report,
		});
		refreshCsrfToken(newSession.csrfToken);
		return newSession;
	}, [fetch, report, refreshCsrfToken]);
}
